import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import { getMuiTheme } from "../Assets/Styles/theme"

const THEME_STORAGE_KEY = "smartspace-theme-mode"

const ThemeContext = createContext()

export const useAppTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useAppTheme must be used within an AppThemeProvider")
  }
  return context
}

const getInitialMode = () => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  if (stored === "light" || stored === "dark") return stored
  return "dark"
}

export const AppThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(getInitialMode)

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode)
    localStorage.setItem(THEME_STORAGE_KEY, mode)
  }, [mode])

  const toggleTheme = useCallback(() => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"))
  }, [])

  const muiTheme = useMemo(() => getMuiTheme(mode), [mode])

  const value = useMemo(
    () => ({ mode, isDark: mode === "dark", toggleTheme, setMode }),
    [mode, toggleTheme],
  )

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  )
}
